// client/src/components/pmPortal/PmPortalPrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePmPortalAuth } from '../../hooks/usePmPortalAuth';

const PmPortalPrivateRoute = ({ children, requireRole = null }) => {
    const { token, role } = usePmPortalAuth();
    if (!token) return <Navigate to="/pm-portal/login" />;
    // A tenant who types an owner URL is sent to their own dashboard rather than shown
    // an error. The server refuses either way; this just avoids a dead end.
    if (requireRole && role !== requireRole) return <Navigate to="/pm-portal" />;
    return children;
};

export default PmPortalPrivateRoute;
